import { Button, Switch, Card, List, Text } from "../../../../components";
import Localization from "../../../../localization";
import { Enums } from "../../../../utils";
import { SVGs } from "../../../../assets";
import styled from "styled-components";
import React from "react";

const Styled = styled(Card)`
  .header > img {
    margin-left: 10rem;
  }
  ${(_) =>
    _.theme.mobile(`
      .header {
        flex-direction: column-reverse;
        align-items: flex-start;
        img {
          margin: 0 0 3rem 0;
        }
      }
  `)}
`;

const Webhooks = ({
  webhooks,
  supportedDevice = {},
  onLearnMore = () => {},
  configureWebhook = () => {},
  toggleActivation = () => {},
  ...props
}) => {
  const renderItem = (_) => {
    const active = !!_?.enabled;
    return (
      <List.Item
        style={{
          paddingTop: "2.5rem",
          paddingBottom: "2.5rem",
        }}
        extra={
          <img
            src={SVGs.cogWheel}
            className="m-10-l cursor-pointer"
            onClick={() => configureWebhook(_)}
            style={{ width: "2rem", height: "2rem" }}
          />
        }
        children={
          <List.Item.Meta
            title={{
              type: "secondary",
              children: Enums.details(_.signal)?.name,
            }}
            avatar={
              <Switch
                className="m-3-r"
                checked={active}
                onChange={() => toggleActivation(_)}
              />
            }
          />
        }
      />
    );
  };

  return (
    <Styled
      {...props}
      title={props.title || supportedDevice?.title}
      extra={
        !!supportedDevice?.logo && <img height={"19rem"} src={SVGs.ajaxSmhi} />
      }
    >
      <Text
        weight={400}
        type="secondary"
        children={Localization.service.smhi_webhooks_desc}
      />
      <List
        className="m-30-t"
        dataSource={webhooks}
        rowKey={(_) => _ + ""}
        highlightOnHover={false}
        renderItem={renderItem}
      />
      <Button
        type={"primary"}
        className="m-35-t"
        onClick={onLearnMore}
        title={Localization.general.learn_more}
      />
    </Styled>
  );
};

export default Webhooks;
